import './functions/utm';
import './functions/select';
import './functions/smoth_scroll';

import '../../blocks/header/header';
import '../../blocks/offers/offers';
import '../../blocks/info/info';
import '../../blocks/faq/faq';
import '../../blocks/select-offers/select-offers';
import '../../blocks/modal/modal';
